export function openUrl(url: string) {
  var openedWindow = window.open();
  openedWindow.opener = null;
  openedWindow.location = url;
}
